// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Variables
     */

    const megamenuOpenTriggers = document.querySelectorAll('.js-open-megamenu');
    const megamenuCloseTriggers = document.querySelectorAll('.js-close-megamenu');
    const megamenus = document.querySelectorAll('.megamenu');

    /**
     * Functions
     */

    const megamenuClose = () => {
        for (const megamenu of megamenus) {
            megamenu.classList.remove('megamenu--visible');
        }
    }

    const megamenuOpen = (megamenuSelector) => {
        for (const megamenu of megamenus) {
            if (megamenu.dataset.megamenu == megamenuSelector) {
                megamenu.classList.add('megamenu--visible');
            }
        }
    }

    /**
     * Triggers
     */

    for (const megamenuOpenTrigger of megamenuOpenTriggers) {

        // Open
        megamenuOpenTrigger.addEventListener('mouseenter', () => {
            const megamenuSelector = megamenuOpenTrigger.dataset.megamenu;
            megamenuOpen(megamenuSelector);
        });

        megamenuOpenTrigger.addEventListener('mouseenter', () => {
            let megamenuSelector = megamenuOpenTrigger.dataset.megamenu;
        
            // if megamenuOpenTrigger has no data-attribut
            if (!megamenuSelector) {
                if (megamenuOpenTrigger.classList.contains('js-open-megamenu-projects')) {
                    megamenuSelector = "projects";
                }
            }
        
            megamenuOpen(megamenuSelector);
        });
        
        // close
        megamenuOpenTrigger.addEventListener('mouseleave', () => {
            megamenuClose();
        });
    }

    for (const megamenuCloseTrigger of megamenuCloseTriggers) {
        megamenuCloseTrigger.addEventListener('mouseenter', () => {
            megamenuClose();
        });
    }

});
